import React, { useEffect, useState, useRef, useMemo, useLayoutEffect } from "react";
import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { useForceUpdate } from "../../../lib";
import { useFormikContext } from "formik";
import { buttonSubmitted } from "../../../lib/helpers";
import { useDispatch } from "../../../state";
import { useSelector, shallowEqual } from "react-redux";
const filter = createFilterOptions(); // remove matchFrom: "start"

export function AddOnTheFlyAutoComplete(props) {
  let forceUpdate = useForceUpdate();
  const {
    errorAlert,
    classes,
    setFieldValue,
    width,
    label,
    list,
    name,
    formik,
    disabled,
  } = props;
  const inputRef = useRef(null);
  const prevInputLengthRef = useRef(0);
  const clearTimerRef = useRef(null);
  const typedLengthRef = useRef(0);
  const [open, toggleOpen] = useState(false);
  const { values } = useFormikContext();
  const [suggestion, setSuggestion] = useState("");
  const [newValue, setNewValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [newFormik, setNewFormik] = useState("");
  const [myBrand, setBrand] = useState("");
  const [myBrandId, setMyBrandId] = useState(Number);
  const [state, setState] = useState(false);

  const formikValue = values[formik];

  // Whether a real option matches the current typed input
  const hasMatches = useMemo(() => {
    if (!inputValue) return false;
    return !!(list || []).find(
      (item) =>
        item[name] && item[name].toLowerCase().startsWith(inputValue.toLowerCase()),
    );
  }, [list, inputValue, name]);

  // After every render where a suggestion is active, restore the selection highlight
  useLayoutEffect(() => {
    if (suggestion && inputRef.current && !formikValue) {
      inputRef.current.setSelectionRange(typedLengthRef.current, suggestion.length);
    }
  });

  const handleChange = () => {};
  const { brand: brand_list } = useSelector(
    (state) => state.watches.watchLists,
    shallowEqual,
  );
  const brandListTitle = useMemo(
    () => brand_list.filter((brands) => brands.brand_id === props.brandAffiliated),
    [brand_list, props.brandAffiliated],
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (newFormik) {
      list.push(newFormik);
      setFieldValue(formik, newFormik[`${name}_id`]);
      setNewFormik(null);
      forceUpdate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFormik]);
  useEffect(() => {
    if (values[`${name}_id`]) {
      forceUpdate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values[`${name}_id`]]);

  const handleClose = () => {
    toggleOpen(false);
  };

  return (
    <>
      <Autocomplete
        className={
          disabled
            ? classes.gridTwoBlack
            : errorAlert
            ? values[formik]
              ? classes.gridTwoBlue
              : classes.gridTwoRed
            : values[formik]
            ? classes.gridTwoBlue
            : classes.gridTwo
        }
        onChange={(e, value) => {
          if (clearTimerRef.current) {
            clearTimeout(clearTimerRef.current);
            clearTimerRef.current = null;
          }
          setSuggestion("");
          if (value === null) {
            setFieldValue(formik, null);
            setNewValue("");
            setInputValue("");
            prevInputLengthRef.current = 0;
            forceUpdate();
          } else if (value?.inputValue) {
            setFieldValue(formik, null);
            setNewValue(value.name);
            setTimeout(() => {
              toggleOpen(true);
            });
            forceUpdate();
          } else if (value[name]) {
            setFieldValue(formik, value[`${name}_id`]);
            forceUpdate();
          }
        }}
        onInputChange={(e, value, reason) => {
          if (reason === "reset") {
            // Option selected or field cleared by MUI — sync state, no debounce timer
            setSuggestion("");
            setInputValue(value || "");
            prevInputLengthRef.current = (value || "").length;
            return;
          }

          const isTypingForward =
            e.type !== "blur" &&
            e.type !== "click" &&
            value.length > prevInputLengthRef.current;
          prevInputLengthRef.current = value.length;

          if (e.type !== "blur" && e.type !== "click") {
            if (!value[`${name}_id`]) {
              if (clearTimerRef.current) clearTimeout(clearTimerRef.current);
              clearTimerRef.current = setTimeout(() => {
                setFieldValue(formik, null);
                clearTimerRef.current = null;
              }, 300);
              setInputValue(value);
            }
            if (isTypingForward && value.length > 0) {
              const match = (list || []).find(
                (item) =>
                  item[name] &&
                  item[name].toLowerCase().startsWith(value.toLowerCase()),
              );
              if (match) {
                typedLengthRef.current = value.length;
                setSuggestion(match[name]);
                prevInputLengthRef.current = match[name].length; // ADD THIS
              } else if (suggestion) {
                prevInputLengthRef.current = suggestion.length; // ADD THIS
              } else {
                typedLengthRef.current = value.length;
              }
            } else if (!isTypingForward) {
              setSuggestion("");
            }
          } else if (e.type === "blur") {
            if (clearTimerRef.current) {
              clearTimeout(clearTimerRef.current);
              clearTimerRef.current = null;
              setFieldValue(formik, null);
            }
            setSuggestion("");
            setInputValue("");
            prevInputLengthRef.current = 0;
          } else if (e.type === "click") {
            setSuggestion("");
            setInputValue(value);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          if (params.inputValue !== "") {
            if (
              !options?.find(
                (x) =>
                  x[name].toLowerCase() === params?.inputValue?.toLowerCase(),
              )
            ) {
              filtered.push({
                inputValue: `Add "${params.inputValue}"`,
                name: params.inputValue,
              });
            }
          }
          return filtered;
        }}
        id="add_on_the_fly_autocomplete"
        disabled={disabled}
        options={list || []}
        getOptionLabel={(option) => {
          if (typeof option === "string") {
            return option[name];
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option[name];
        }}
        clearOnBlur={!values[`${name}_id`]}
        autoSelect={hasMatches && inputValue.length > 0}
        autoHighlight={hasMatches && inputValue.length > 0}
        handleHomeEndKeys
        style={{ width: width }}
        renderInput={(params) => {
          const muiInputRef = params.inputProps.ref;
          const displayValue = formikValue
            ? list?.find((x) => x[`${name}_id`] === formikValue)?.[name] || ""
            : suggestion || params.inputProps.value || "";
          return (
            <TextField
              {...params}
              inputProps={{
                ...params.inputProps,
                value: displayValue,
                ref: (el) => {
                  inputRef.current = el;
                  if (typeof muiInputRef === "function") muiInputRef(el);
                  else if (muiInputRef) muiInputRef.current = el;
                },
              }}
              label={label}
              InputLabelProps={{ shrink: true }}
              multiline
            />
          );
        }}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="form-dialog-title">
          {"Add " + newValue + " To " + label + "?"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            id="name"
            value={newValue}
            onChange={(e, value) => setNewValue(e.target.value)}
            label="Name"
            type="text"
            style={{ width: "100%" }}
          />
          {props.brandAffiliated && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.checkedB}
                  onChange={(event, value) => {
                    if (value) {
                      setBrand(brandListTitle[0].brand);
                      setMyBrandId(brandListTitle[0].brand_id);
                    } else {
                      setBrand(null);
                      setMyBrandId(null);
                    }
                  }}
                  color="primary"
                />
              }
              label={`Add affiliation with ${brandListTitle[0]?.brand}?`}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setInputValue("");
              handleClose();
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              buttonSubmitted({
                Add_Edit_Delete: "add",
                rawAttribute: name,
                myValue: newValue,
                attribute: label,
                dispatch,
                siteId: 0,
                setNewFormik: setNewFormik,
                myBrandId: myBrandId,
              });
              handleClose();
            }}
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
